import {
  Tooltip,
  // Badge,
  tooltipClasses,
  styled
  // useTheme
} from '@mui/material';
import { Link } from 'react-router-dom';
import Logo_ from '../../assets/images/logo/logo192.png';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 53px;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

function Logo() {
  // const theme = useTheme();

  return (
    <TooltipWrapper title="Home" arrow>
      <LogoWrapper to="/">
        <img style={{ marginLeft: -80, height: 50 }} alt="" src={Logo_} />
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
